const TOOLS = {
    serverURL : "https://appstore.escolhatecnologia.com.br/api/adm",  
    siteURL : "https://appstore.escolhatecnologia.com.br"
    //serverURL : "http://localhost/new-appstore/api/adm",
    //siteURL : "http://localhost:3000"
}

export default TOOLS;


// WEBPACK FOOTER //
// ./src/componentes/TOOLS.js